import { Texture } from './Texture';
import { Context } from '../context/Context';

export class ImageTexture extends Texture {
  constructor(public config: TextureSettings) {
    super();
    this.glTexture = null;
    this.translucent = false;
  }

  public async load(ctx: Context): Promise<ImageTexture> {
    let imageData = await ctx.resourceLoader.loadImageResource(this.config.source);
    this.uploadImageData(ctx, imageData.data, imageData.width, imageData.height, true);
    return this;
  }
}

type TextureSettings = {
  source: string;
};
